import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import * as getters from './getters'
import { setCookie } from 'tiny-cookie'
Vue.use(Vuex)

const getDefaultState = () => {
  return {
    settings: {
      username: '',
      user: {},
      menus: ['view_snapshot'],
      isIniting: true,
      usertype: 3,
      role: '',
      permList: ['view_snapshot'],
    },
    profile: {
      email: '',
      username: '',
      campaign_new_user: 0,
      customer_type: 0, // 0-sele,1-agent,2-direct
      discount_type: 0, // 0-nodiscount, 1-other, 2-20%'; 3-35%
      dicount: 0,
      need_fill: false,
      phone: '',
    },
    active_menu: '',
    message: {
      show: true,
      data: [],
    },
    introStepInfo: {
      // isIntro:0,// skip: 0 ,done: 1；
      complete_guide: 1, // 是否完成用户引导
      currentStep: '', // 当前第几步 Number(sessionStorage.getItem('currentStep'))||
    },
    popVisible2: false,
    holiday: {
      banner_img: '',
      mobile_banner_img: '',
      start: '',
      title: '',
      banner_sub_heading: '',
      banner_main_heading: '',
      popup_img: '',
      end: '',
      create_time: '',
    },
  }
}
// 应用初始状态
const state = getDefaultState()

// 定义所需的 mutations
const mutations = {
  PROFILE(state, data) {
    if (data.email || data.phone) {
      setCookie('login', true)
      state.profile = data
      // data.need_fill = 1
      state.profile.need_fill = Boolean(data.need_fill)
    }
  },
  RESET(state) {
    Object.assign(state, getDefaultState())
  },
  ACTIVE_MENU(state, data) {
    state.active_menu = data
  },
  SET_MESSAGE(state, data) {
    if (data.data.message === null || data.data.message.length === 0) {
    } else {
      let arr = data.data.message.map(i => {
        i.show = true
        return i
      })
      state.message.data.push(...arr)
    }
  },
  RESET_MESSAGE(state, index) {
    state.message.data.splice(index, 1)
  },
  UPDATE_POP(state, status) {
    state.popVisible2 = status
  },
  SET_HOLIDAY(state, data) {
    if (data.length > 0) {
      state.holiday = data[0]
    }
  },
  UPDATE_NEED_FILL(state, status) {
    state.profile.need_fill = status
  },
}

// 创建 store 实例
export default new Vuex.Store({
  actions,
  getters,
  state,
  mutations,
})
